import { mode } from '@chakra-ui/theme-tools';
var baseStyle = {
  lineHeight: '1.8',
  fontWeight: '700',
  border: '1px solid',
  borderRadius: 'base',
  _focus: {
    boxShadow: 'none'
  },
  _disabled: {
    opacity: 0.5,
    cursor: 'not-allowed'
  }
};

function variantOutline(props) {
  var {
    colorScheme: c
  } = props;
  return {
    color: mode(c + ".500", c + ".100")(props),
    borderColor: mode(c + ".500", c + ".100")(props),
    bg: 'transparent',
    ':active, :focus': {
      borderColor: mode(c + ".800", c + ".100")(props),
      color: mode(c + ".200", c + ".100")(props),
      bg: 'transparent'
    },
    _hover: {
      borderColor: mode(c + ".200", c + ".100")(props),
      color: mode(c + ".200", c + ".100")(props),
      bg: 'transparent'
    }
  };
}

/** Accessible color overrides for less accessible colors. */
var accessibleColorMap = {
  yellow: {
    bg: 'yellow.400',
    color: 'black',
    hoverBg: 'yellow.500'
  },
  cyan: {
    bg: 'cyan.400',
    color: 'black',
    hoverBg: 'cyan.500'
  }
};

function variantSolidDark(props) {
  var {
    colorScheme: c
  } = props;
  var {
    bg = c + ".700",
    color = 'white',
    hoverBg = c + ".600"
  } = accessibleColorMap[c] || {};
  var background = mode(bg, c + ".200")(props);
  return {
    bg: background,
    color: mode(color, 'black')(props),
    _hover: {
      bg: mode(hoverBg, c + ".200")(props),
      _disabled: {
        bg: background
      }
    },
    ':focus, :active': {
      bg: mode(bg, c + ".200")(props),
      borderColor: mode(c + ".500", bg)(props)
    }
  };
}

function variantSolidLight(props) {
  var {
    colorScheme: c
  } = props;
  var {
    bg = c + ".500",
    color = 'white',
    hoverBg = c + ".200"
  } = accessibleColorMap[c] || {};
  var background = mode(bg, c + ".200")(props);
  return {
    bg: background,
    color: mode(color, 'black')(props),
    _hover: {
      bg: mode(hoverBg, c + ".200")(props),
      _disabled: {
        bg: background
      }
    },
    ':focus, :active': {
      bg: mode(bg, c + ".200")(props),
      borderColor: mode(c + ".700", bg)(props)
    }
  };
}

function variantLink(props) {
  var {
    colorScheme: c
  } = props;
  return {
    padding: 0,
    height: 'auto',
    lineHeight: 'normal',
    color: mode(c + ".500", c + ".200")(props),
    border: 'none',
    _hover: {
      textDecoration: 'underline',
      _disabled: {
        textDecoration: 'none'
      }
    },
    _active: {
      color: mode(c + ".700", c + ".500")(props)
    }
  };
}

var variantUnstyled = {
  bg: 'none',
  color: 'inherit',
  display: 'inline',
  lineHeight: 'inherit',
  m: 0,
  p: 0
};
var variants = {
  outline: variantOutline,
  solidDark: variantSolidDark,
  solidLight: variantSolidLight,
  link: variantLink,
  unstyled: variantUnstyled
};
var defaultProps = {
  size: 'md',
  colorScheme: 'brand',
  variant: 'solidLight'
};
export default {
  baseStyle,
  defaultProps,
  variants
};
//# sourceMappingURL=Button.js.map